<template>
  <div class="check">
    <div class="status" v-if="state == 2">
      <img src="/static/images/error.png" width="192px" height="174px">
      <h3>未完成规定学时暂不允许考试</h3>
      <p>请您完成{{Data1.totalPxTime}}学时学习内容后再来参加考试</p>
      <a href="/" class="back">返回首页</a>
    </div>
    <div class="status" v-else-if="state == 1">
      <img src="/static/images/pass.png" width="160px" height="160px">
      <h3>您已完成规定学时，祝您考试顺利</h3>
      <p>考试时间为60分钟，一旦参加考试不可中途退出，否则考试视为作废，请您认真答题</p>
      <a href="/" class="back">返回首页</a>
      <div class="join" @click="joinExam()">参加考试</div>
    </div>
    <div class="status" v-else-if="state == 3">
      <img src="/static/images/error.png" width="192px" height="174px">
      <h3>很抱歉，您的考试成绩不合格，不予通过，请重新补考</h3>
      <p>目前不限制补考次数，祝您考试顺利</p>
      <a href="/" class="back">返回首页</a>
      <div class="join" @click="joinExam()">参加补考</div>
    </div>
    <div class="exam" v-else-if="state == 4">
      <intheexam :lxId="lxId"></intheexam>
    </div>
    <div class="status" v-else-if="state == 5">
      <img src="/static/images/pass.png" width="192px" height="174px">
      <h3>恭喜您，已通过考试！</h3>
      <p style="margin-bottom: -20px;">已完成{{Data1.xxglYxxs}}学时课程</p>
      <p style="font-weight: 700; color: #0374ff;"><span   v-if="qyFwnr != 0">请点“申请报告”提交材料后等待审核</span></p>
      <a href="/" class="back">返回首页</a>
      <div class="join" @click="downs(6)">预览培训证明</div>
      <div class="join" @click="dialogVisible = true">预览成绩单</div>
      <div class="join" @click="apply()">申请报告</div>
    </div>

	<el-dialog
	  :visible.sync="dialogVisible"
	  top="5vh"
	  width="1000px">
	  <cjd :cj="Data1"></cjd>
	</el-dialog>
  </div>
</template>

<script>
	import { cookie } from "@/common/js/cookies.js";
  import  intheexam from '@/components/exam/intheexam'
  import  cjd from '@/components/exam/cjd'
  export default {
    name: "check",
    data() {
      return {
        Data: null,
        Data1: null,
        dialogVisible: false,
        state : -1,
        qyId: null,
        qyFwnr: 0,
        lxId: null,  //课程类型Id
      }
    },
    mounted() {
      this.lxId = this.$route.query.lxId;
      // this.getData();
      this.getData1()
    },
    methods: {
	//获取成绩单
    getData1: function () {
      let _self = this;
      let ajax = _self.$http.create();
      let data = {
        lxId:this.lxId
      };
      const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
      });
      ajax({
      method: 'post',
      url: SOWINURL + 'XxKh/getEnterpriseCenter',
      data: data,
      headers:{
        'token': cookie.get("xyxf_token_qt")
      }
	  }).then(function (json) {
		if (json.data.result == 1) {
		  _self.Data1 = json.data.data;
		  _self.qyId = json.data.data.qyId;
      _self.qyFwnr = json.data.data.qyFwnr;
      _self.getData();
		} else {
		  _self.$message({
			showClose: true,
			message: json.data.errorcode,
			type: 'error'
		  });
		}
		loading.close();

	  }).catch(function (error) {
		loading.close();
		console.log(error);
	  });
	},
    apply() {
      this.$router.push({
        path: "/qyrz",
        query: {
          qyId: this.qyId,
          lxCjbg: this.lxCjbg,
          qyActive: 0,
          isApplyFor: 1, //区分是申请报告还是关联外省企业
          pxlx: this.lxId,
        },
      });
    },
	//预览培训证明
	downs(type){
	  let _self = this;
	  let ajax = _self.$http.create();
		const loading = this.$loading({
		  lock: true,
		  text: 'Loading',
		  spinner: 'el-icon-loading',
		  background: 'rgba(0, 0, 0, 0.7)'
		});
	  ajax({
		method: "post",
		url: SOWINURL + "report/getQyfj",
		data:{
			qyId: _self.qyId,
			fjType: type
		},
		headers:{
			'token': cookie.get("xyxf_token_qt")
		}
	  })
	  .then(function(json) {
		  _self.download(json.data.data)
		  loading.close();
	  })
	  .catch(function(error) {
			loading.close();
		console.log(error);
	  })
	},
	download (data) {
	        if (!data) {
	            return
	        }
	        let url = data;
	        let link = document.createElement('a')
	        link.style.display = 'none'
	        link.href = url
	        link.setAttribute('download', '')
			link.setAttribute('target', '_blank')

	        document.body.appendChild(link)
	        link.click()
	},
      joinExam : function(){//参加考试
        let _self = this;
        _self.$confirm('考试时间为60分钟，是否现在开始考试？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ajax = _self.$http.create();
          let data = {
            lxId:this.lxId
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          ajax({
            method: 'post',
            url: SOWINURL + 'XxKh/GeneratTestPapers',
            data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
          }).then(function (json) {
            if (json.data.result == 1) {
              // _self.Data = json.data.data;
              window.location.reload();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: 'error'
              });
            }
            loading.close();

          }).catch(function (error) {
            console.log(error);
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      getData: function () {
        let _self = this;
        let ajax = _self.$http.create();
        let data = {
          qyId:this.qyId,
          lxId:this.lxId
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ajax({
          method: 'post',
          url: SOWINURL + 'XxKh/verificationQualification',
          data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
        }).then(function (json) {
          _self.state = json.data.result;
          // if (json.data.result == 1) {
          //   _self.Data = json.data.data;
          // } else {
          //   _self.$message({
          //     showClose: true,
          //     message: json.data.errorcode,
          //     type: 'error'
          //   });
          // }
          loading.close();

        }).catch(function (error) {
          console.log(error);
        });
      },
    },
    components: {
      intheexam,
	  cjd
    },
  }
</script>

<style scoped lang="less" type="text/less">
  .status {
    padding-top: 130px;
    background: #fff;
    text-align: center;
    padding-bottom: 200px;
    margin-bottom: 20px;
    .back, .join {
      width: 158px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border-radius: 24px;
      border: 1px solid #0374ff;
      font-size: 18px;
      color: #0374ff;
      display: block;
      display: inline-block;
      margin: 0 40px 0 40px;
    }

    .join {
      color: #fff;
      border: none;
      width: 160px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: -webkit-linear-gradient(left, #0076ff, #00c9ff); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(right, #0076ff, #00c9ff); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(right, #0076ff, #00c9ff); /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
    }

    img {
      display: block;
      margin: 0 auto;
    }

    h3 {
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 30px;
      color: #02113a;
    }

    p {
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 16px;
      color: #070d4b;
      margin-bottom: 100px;
    }
  }
  .exam{
    padding: 50px 100px;
    background: #fff;
    margin-bottom: 20px;

  }
</style>



// WEBPACK FOOTER //
// src/components/exam/check.vue